// extracted by mini-css-extract-plugin
module.exports = {"container":"productTag_container__xX5fX"};